(function(){function sheathSelectUrlColor(){if(!/\/products\//.test(location.pathname))return;var vid=new URLSearchParams(location.search).get('variant');if(!vid)return;var h=location.pathname.split('/products/')[1].split(/[/?#]/)[0];fetch('/products/'+h+'.js').then(function(r){return r.json()}).then(function(p){var v=p.variants.find(function(x){return String(x.id)===vid});if(!v)return;var i=p.options.findIndex(function(o){return /colou?r/i.test(o.name||o)});if(i<0)return;var c=v.options[i],k='option'+(i+1),rs=document.querySelectorAll('input[type=radio][data-index="'+k+'"]');for(var j=0;j<rs.length;j++){if(rs[j].value===c){if(!rs[j].checked)rs[j].click();break}}}).catch(function(){})}function run(){setTimeout(sheathSelectUrlColor,300)}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run)}else{run()}})();
(function(){var cache={};function img(u,w){return u+(u.indexOf('?')>-1?'&':'?')+'width='+w}function pick(p,vid){var v=p.variants.find(function(x){return String(x.id)===vid});if(!v||!v.featured_media)return null;var starts=[];p.variants.forEach(function(x){if(x.featured_media&&starts.indexOf(x.featured_media.position)<0)starts.push(x.featured_media.position)});var s=v.featured_media.position,e=p.media.length+1;starts.forEach(function(q){if(q>s&&q<e)e=q});var blk=p.media.filter(function(m){return m.position>s&&m.position<e&&m.media_type==='image'});if(!blk.length)return null;var mod=blk.find(function(m){return /model/i.test((m.src||'')+' '+(m.alt||''))});return (mod||blk[0]).src}function fix(card){var a=card.querySelector('a[href*="/products/"][href*="variant="]');var sec=card.querySelector('.grid-product__secondary-image img');if(!a||!sec||card.dataset.sheathHover===a.href)return;card.dataset.sheathHover=a.href;var u=new URL(a.href,location.origin);var vid=u.searchParams.get('variant');var h=u.pathname.split('/products/')[1].split('/')[0];(cache[h]=cache[h]||fetch('/products/'+h+'.js').then(function(r){return r.json()})).then(function(p){var src=pick(p,vid);if(!src)return;sec.src=img(src,720);sec.srcset=[180,360,540,720,900,1080].map(function(w){return img(src,w)+' '+w+'w'}).join(', ')}).catch(function(){})}function run(){if(!/\/collections\//.test(location.pathname))return;document.querySelectorAll('.grid-product').forEach(fix)}var t;function later(){clearTimeout(t);t=setTimeout(run,200)}function start(){run();new MutationObserver(later).observe(document.body,{childList:true,subtree:true})}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',start)}else{start()}})();
// Keep keyboard focus visible and clear stale inert/aria-hidden locks on the header toolbar
(function () {
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') {
      document.documentElement.classList.add('tab-outline');
    }
  });

  document.addEventListener('mousedown', function () {
    document.documentElement.classList.remove('tab-outline');
  });

  function clearStaleAccessibilityLocks() {
    var modalOpen = document.querySelector('.modal--is-active');
    var drawerOpen = document.documentElement.classList.contains('js-drawer-open');

    if (modalOpen || drawerOpen) {
      return;
    }

    if (window.theme && theme.a11y && theme.a11y.clearPageAccessibilityLocks) {
      theme.a11y.clearPageAccessibilityLocks();
      return;
    }

    document
      .querySelectorAll('#MainContent, .shopify-section-group-footer-group, [data-section-type="header"]')
      .forEach(function (el) {
        el.removeAttribute('inert');
        el.removeAttribute('aria-hidden');
      });
  }

  document.addEventListener('DOMContentLoaded', clearStaleAccessibilityLocks);
  document.addEventListener('modalClose', clearStaleAccessibilityLocks);
  document.addEventListener('cart:close', clearStaleAccessibilityLocks);
})();

// Cart count start
document.addEventListener('DOMContentLoaded', function () {
  function getCartAriaLabel(cartButton, count) {
    if (!cartButton) return '';

    if (count === 0) {
      return cartButton.dataset.cartLabelEmpty || 'Cart';
    }

    if (count === 1) {
      return (cartButton.dataset.cartLabelOne || 'Cart, __COUNT__ item').replace('__COUNT__', count);
    }

    return (cartButton.dataset.cartLabelOther || 'Cart, __COUNT__ items').replace('__COUNT__', count);
  }

  function updateCartAccessibility(cartButton, count) {
    if (!cartButton) return;

    const label = getCartAriaLabel(cartButton, count);
    cartButton.setAttribute('aria-label', label);

    const fallback = cartButton.querySelector('.icon__fallback-text');
    if (fallback) {
      fallback.textContent = label;
    }
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        const cartCount = data.item_count;
        const cartBubble = document.querySelector('.cart-link__bubble');
        const cartButton = document.querySelector('.js-drawer-open-cart');

        if (cartCount > 0) {
          if (cartBubble) {
            cartBubble.textContent = cartCount;
            cartBubble.classList.add('cart-link__bubble--visible');
          }
        } else if (cartBubble) {
          cartBubble.textContent = '';
          cartBubble.classList.remove('cart-link__bubble--visible');
        }

        updateCartAccessibility(cartButton, cartCount);
      })
      .catch(error => console.error('Error fetching cart data:', error));
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(updateCartCount, { timeout: 2500 });
  } else {
    updateCartCount();
  }
  document.addEventListener('cart:updated', updateCartCount);

  document.addEventListener('click', function (event) {
    if (
      event.target.matches('.add-to-cart-button') || 
      event.target.closest('button[data-add-to-cart]')
    ) {
      // Wait 3 seconds, then trigger the existing cart refresh flow.
      setTimeout(() => {
        const event = new CustomEvent('cart:updated');
        document.dispatchEvent(event);
      }, 3000); // 3 seconds delay
    }
  });
});

// Cart count end

// "Back to Top" start — passive scroll + rAF avoids forced reflow on every scroll tick
(function () {
  var backToTopButton = document.getElementById('back-to-top');
  if (!backToTopButton) return;

  var ticking = false;
  var lastVisible = null;
  var cartButton = document.querySelector('.js-drawer-open-cart');

  function isCartOpen() {
    if (!cartButton || !document.body.contains(cartButton)) {
      cartButton = document.querySelector('.js-drawer-open-cart');
    }
    return cartButton && cartButton.getAttribute('aria-expanded') === 'true';
  }

  function updateBackToTop() {
    ticking = false;
    var scrolled = window.scrollY > 100;
    var visible = scrolled && !isCartOpen();

    if (visible === lastVisible) return;
    lastVisible = visible;
    backToTopButton.style.display = visible ? 'block' : 'none';
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateBackToTop);
      }
    },
    { passive: true }
  );

  backToTopButton.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  document.addEventListener('cart:open', updateBackToTop);
  document.addEventListener('cart:close', updateBackToTop);
  document.addEventListener('cart:updated', updateBackToTop);
})();
// "Back to Top" end

// carousel start — init when section scrolls near viewport (less main-thread work on load)
function initCarouselSection(section) {
  if (section.dataset.carouselInit === "true") return;
  section.dataset.carouselInit = "true";

  const carousel = section.querySelector(".carousel-container");
  const slides = section.querySelectorAll(".carousel-slide");
  const prevButton = section.querySelector("[data-carousel='prev']");
  const nextButton = section.querySelector("[data-carousel='next']");

  if (!carousel || !slides.length || !prevButton || !nextButton) return;

  function handleCarouselMove(positive = true) {
    const slideWidth = slides[0].clientWidth;
    if (!slideWidth) return;
    const visibleCount = Math.max(1, Math.floor(carousel.clientWidth / slideWidth));
    const moveDistance = slideWidth * visibleCount;
    carousel.scrollLeft = positive
      ? carousel.scrollLeft + moveDistance
      : carousel.scrollLeft - moveDistance;
  }

  prevButton.addEventListener("click", () => handleCarouselMove(false));
  nextButton.addEventListener("click", () => handleCarouselMove(true));
}

function initProductGridSliders(root) {
  const scope = root && typeof root.querySelectorAll === "function" ? root : document;
  scope.querySelectorAll(".product-grid-slider").forEach(initCarouselSection);
}

window.initProductGridSliders = initProductGridSliders;

document.addEventListener("DOMContentLoaded", () => {
  const carouselSections = document.querySelectorAll(".product-grid-slider");
  if (!carouselSections.length) return;

  carouselSections.forEach((section) => {
    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              initCarouselSection(entry.target);
              obs.unobserve(entry.target);
            }
          });
        },
        { rootMargin: "200px 0px" }
      );
      observer.observe(section);
    } else {
      initCarouselSection(section);
    }
  });
});

document.addEventListener("recommendations:loaded", (event) => {
  if (event.detail && event.detail.section) {
    initProductGridSliders(event.detail.section);
  }
});

// carousel end

// input field validation start
document.addEventListener("DOMContentLoaded", function () {
  const fields = [
    { selector: "#CustomerEmail", validate: validateEmailField },
    { selector: "#CustomerPassword", validate: validatePasswordField },
    { selector: "#RecoverEmail", validate: validateEmailField },
    { selector: "#FirstName", validate: (input) => validateTextField(input, "First name is required.") },
    { selector: "#LastName", validate: (input) => validateTextField(input, "Last name is required.") },
    { selector: "#Email", validate: validateEmailField },
    { selector: "#CreatePassword", validate: (input) => validateTextField(input, "Password is required.") }
  ];

  fields.forEach(({ selector, validate }) => {
    const field = document.querySelector(selector);
    if (field) {
      field.addEventListener("focus", () => clearErrorMessage(field));
      field.addEventListener("blur", () => validate(field));
    }
  });

  function validateTextField(input, message) {
    if (!input.value.trim()) {
      showErrorMessage(input, message);
    }
  }

  function validateEmailField(input) {
    if (!input.value.trim()) {
      showErrorMessage(input, "Email is required.");
    } else if (!validateEmail(input.value)) {
      showErrorMessage(input, "Please enter a valid email address.");
    }
  }

  function validatePasswordField(input) {
    if (!input.value.trim()) {
      showErrorMessage(input, "Password is required.");
    }
  }

  function showErrorMessage(input, message) {
    let error = input.nextElementSibling;
    if (!error || !error.classList.contains("error-message")) {
      error = document.createElement("div");
      error.classList.add("error-message");
      error.style.color = "red";
      input.parentNode.insertBefore(error, input.nextSibling);
    }
    error.textContent = message;
    input.classList.add("error");
  }

  function clearErrorMessage(input) {
    input.classList.remove("error");
    const error = input.nextElementSibling;
    if (error && error.classList.contains("error-message")) {
      error.remove();
    }
  }

  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  }
});

// input field validation end

// Remove default variant selection start
function getProductFormFromInput(input) {
  if (!input) {
    return null;
  }

  if (input.form && input.form.classList.contains('product-single__form')) {
    return input.form;
  }

  const formId = input.getAttribute('form');
  if (formId) {
    return document.getElementById(formId);
  }

  return input.closest('.product-single__form');
}

function getVariantInputsForForm(form) {
  if (!form) {
    return [];
  }

  const scope =
    form.closest('.product-section') ||
    form.closest('.modal--quick-shop') ||
    document;

  let inputs = [];

  if (form.elements && form.elements.length) {
    inputs = Array.prototype.filter.call(form.elements, function (el) {
      return el.hasAttribute && el.hasAttribute('data-variant-input');
    });
  }

  if (!inputs.length && form.id) {
    inputs = Array.prototype.slice.call(
      scope.querySelectorAll('[data-variant-input][form="' + form.id + '"]')
    );
  }

  if (!inputs.length) {
    inputs = Array.prototype.filter.call(scope.querySelectorAll('[data-variant-input]'), function (el) {
      const linkedFormId = el.getAttribute('form');
      if (linkedFormId) {
        return linkedFormId === form.id;
      }
      return form.contains(el);
    });
  }

  return inputs;
}

function hasSelectedVariantOption(variantInputs) {
  if (!variantInputs.length) {
    return false;
  }

  const radios = variantInputs.filter(function (input) {
    return input.type === 'radio';
  });

  if (radios.length) {
    return radios.some(function (input) {
      return input.checked;
    });
  }

  return variantInputs.some(function (input) {
    return input.value;
  });
}

function syncVariantFirstButtonsForForm(form) {
  const addToCartButton = form.querySelector('[data-add-to-cart]');
  const selectVariantFirstButton = form.querySelector('.select_variant_first_custom');
  const paymentButton = form.querySelector('[data-shopify="payment-button"]');
  const variantInputs = getVariantInputsForForm(form);

  if (!variantInputs.length || !addToCartButton || !selectVariantFirstButton) {
    return;
  }

  if (hasSelectedVariantOption(variantInputs)) {
    selectVariantFirstButton.style.display = 'none';
    addToCartButton.style.display = 'block';
    if (paymentButton) {
      paymentButton.style.display = 'block';
    }
  } else {
    selectVariantFirstButton.style.display = 'block';
    addToCartButton.style.display = 'none';
    if (paymentButton) {
      paymentButton.style.display = 'none';
    }
  }
}

function initVariantFirstButtons(scope) {
  const root = scope || document;

  root.querySelectorAll('.product-single__form').forEach(function (form) {
    syncVariantFirstButtonsForForm(form);
  });
}

if (!window.__variantFirstChangeBound) {
  window.__variantFirstChangeBound = true;

  document.addEventListener('change', function (event) {
    const target = event.target;
    if (!target || !target.matches || !target.matches('[data-variant-input]')) {
      return;
    }

    const form = getProductFormFromInput(target);
    if (form) {
      syncVariantFirstButtonsForForm(form);
    }
  });

  document.addEventListener('variant:change', function () {
    initVariantFirstButtons(document);
  });
}

function scheduleVariantFirstInit(scope) {
  initVariantFirstButtons(scope || document);
  requestAnimationFrame(function () {
    initVariantFirstButtons(scope || document);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  scheduleVariantFirstInit(document);
});

document.addEventListener('shopify:section:load', function () {
  scheduleVariantFirstInit(document);
});

function refreshQuickViewCarouselFocus(modal) {
  if (!modal || !window.theme || !theme.a11y) {
    return;
  }

  modal.querySelectorAll('[data-product-photos]').forEach(function (carousel) {
    theme.a11y.updateCarouselSlideFocus(carousel);
  });
}

document.addEventListener('quickview:loaded', function (event) {
  const productId = event.detail && event.detail.productId;
  const modal = productId ? document.getElementById('QuickShopModal-' + productId) : null;
  scheduleVariantFirstInit(modal || document);
  requestAnimationFrame(function () {
    refreshQuickViewCarouselFocus(modal);
  });
});

document.addEventListener('quickview:open', function (event) {
  if (!event.detail) {
    return;
  }

  const productId = event.detail.productId;
  const modal = productId ? document.getElementById('QuickShopModal-' + productId) : null;
  scheduleVariantFirstInit(modal || document);
  requestAnimationFrame(function () {
    refreshQuickViewCarouselFocus(modal);
  });
});

// Quick shop modal — Tab / Shift+Tab stay inside popup
(function () {
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function getActiveQuickShopModal() {
    return document.querySelector('.modal--quick-shop.modal--is-active');
  }

  function getFocusableNodes(modal) {
    if (window.theme && theme.a11y && theme.a11y.getFocusableElements) {
      return theme.a11y.getFocusableElements(modal);
    }

    return Array.prototype.filter.call(modal.querySelectorAll(FOCUSABLE), function (el) {
      return el.getClientRects().length > 0 && !el.closest('[hidden]');
    });
  }

  function getFocusedIndex(nodes) {
    if (window.theme && theme.a11y && theme.a11y.getFocusedIndex) {
      return theme.a11y.getFocusedIndex(nodes);
    }

    var active = document.activeElement;
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i] === active) {
        return i;
      }
    }
    return -1;
  }

  function onKeydown(e) {
    if (e.key !== 'Tab' && e.keyCode !== 9) {
      return;
    }

    var modal = getActiveQuickShopModal();
    if (!modal) {
      return;
    }

    var nodes = getFocusableNodes(modal);
    if (!nodes.length) {
      return;
    }

    var index = getFocusedIndex(nodes);
    var first = nodes[0];
    var last = nodes[nodes.length - 1];

    if (e.shiftKey) {
      if (index <= 0) {
        e.preventDefault();
        e.stopImmediatePropagation();
        last.focus();
      }
    } else if (index === nodes.length - 1) {
      e.preventDefault();
      e.stopImmediatePropagation();
      first.focus();
    }
  }

  function onFocusin(e) {
    var modal = getActiveQuickShopModal();
    if (!modal || modal.contains(e.target)) {
      return;
    }

    var nodes = getFocusableNodes(modal);
    if (nodes[0]) {
      nodes[0].focus();
    }
  }

  document.addEventListener('keydown', onKeydown, true);
  document.addEventListener('focusin', onFocusin, true);
})();

// Remove default variant selection end

// Cart drawer focus trap — Tab / Shift+Tab stay inside drawer
(function () {
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var active = false;
  var drawer = null;
  var onKeydown = null;
  var onFocusin = null;

  function isCartOpen() {
    var el = document.getElementById('CartDrawer');
    return (
      el &&
      el.classList.contains('drawer--is-open') &&
      document.documentElement.classList.contains('js-drawer-open')
    );
  }

  function getFocusableNodes(container) {
    return Array.prototype.filter.call(container.querySelectorAll(FOCUSABLE), function (el) {
      return el.getClientRects().length > 0 && !el.closest('[hidden]');
    });
  }

  function lockPageBehindDrawer(lock) {
    var nodes = document.querySelectorAll('#MainContent, .shopify-section-group-footer-group');
    nodes.forEach(function (el) {
      if (lock) {
        el.setAttribute('inert', '');
        el.setAttribute('aria-hidden', 'true');
      } else {
        el.removeAttribute('inert');
        el.removeAttribute('aria-hidden');
      }
    });
  }

  function clearThemeTraps() {
    if (window.theme && theme.a11y) {
      theme.a11y.removeTrapFocus({ namespace: 'drawer_focus' });
      theme.a11y.removeTrapFocus({ namespace: 'cartdrawer_focus' });
    }
  }

  function enableTrap() {
    drawer = document.getElementById('CartDrawer');
    if (!isCartOpen() || !drawer) {
      disableTrap();
      return;
    }

    disableTrap();
    active = true;
    clearThemeTraps();
    lockPageBehindDrawer(true);

    onKeydown = function (e) {
      if (!active || (e.key !== 'Tab' && e.keyCode !== 9)) {
        return;
      }

      var nodes = getFocusableNodes(drawer);
      if (!nodes.length) {
        return;
      }

      var first = nodes[0];
      var last = nodes[nodes.length - 1];

      if (e.shiftKey) {
        if (e.target === first || !drawer.contains(e.target)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          last.focus();
        }
      } else if (e.target === last || !drawer.contains(e.target)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        first.focus();
      }
    };

    onFocusin = function (e) {
      if (!active || !drawer || drawer.contains(e.target)) {
        return;
      }
      var nodes = getFocusableNodes(drawer);
      if (nodes[0]) {
        nodes[0].focus();
      }
    };

    document.addEventListener('keydown', onKeydown, true);
    document.addEventListener('focusin', onFocusin, true);

    var closeBtn = drawer.querySelector('.js-drawer-close');
    if (closeBtn) {
      closeBtn.focus();
    }
  }

  function disableTrap() {
    active = false;
    if (onKeydown) {
      document.removeEventListener('keydown', onKeydown, true);
      onKeydown = null;
    }
    if (onFocusin) {
      document.removeEventListener('focusin', onFocusin, true);
      onFocusin = null;
    }
    lockPageBehindDrawer(false);
  }

  function scheduleEnable() {
    requestAnimationFrame(function () {
      requestAnimationFrame(enableTrap);
    });
  }

  document.addEventListener('drawerOpen.CartDrawer', scheduleEnable);
  document.addEventListener('drawerOpen.FilterDrawer', disableTrap);
  document.addEventListener('cart:open', scheduleEnable);
  document.addEventListener('cart:updated', function () {
    if (active) {
      scheduleEnable();
    }
  });

  document.addEventListener('cart:close', function () {
    disableTrap();
    if (window.theme && theme.a11y && theme.a11y.clearPageAccessibilityLocks) {
      theme.a11y.clearPageAccessibilityLocks();
    }
  });

  var htmlObserver = new MutationObserver(function () {
    if (isCartOpen()) {
      if (!active) {
        scheduleEnable();
      }
    } else if (active) {
      disableTrap();
    }
  });
  htmlObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
})();

// Collection swatch overflow (+N) — tap to expand on touch devices
document.addEventListener('click', function (event) {
  var moreBtn = event.target.closest('.grid-product__swatch-more');
  if (moreBtn) {
    event.preventDefault();
    event.stopPropagation();
    var colors = moreBtn.closest('.grid-product__colors--limited');
    if (colors) {
      colors.classList.toggle('is-expanded');
    }
    return;
  }

  if (!event.target.closest('.grid-product__colors--limited')) {
    document.querySelectorAll('.grid-product__colors--limited.is-expanded').forEach(function (el) {
      el.classList.remove('is-expanded');
    });
  }
});